module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-sketch-4-c52e4127ffb9771f9ff7c1096833720b.svg";